import * as React from 'react';
import { TooltipHost } from '@fluentui/react';

const MS_CERTIFIED_URL = 'https://reenhanced.com/wp-content/uploads/2025/11/ms-certified-150x75.png';

export const MsCertifiedBadge: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <TooltipHost content="Microsoft Certified connector — verified and published in the Microsoft Power Automate connector gallery.">
    <img
      src={MS_CERTIFIED_URL}
      alt="Microsoft Certified"
      style={{ width: '120px', verticalAlign: 'middle', ...style }}
    />
  </TooltipHost>
);

export default MsCertifiedBadge;
